import { render, staticRenderFns } from "./ContadorEntidade.vue?vue&type=template&id=2c810151"
import script from "./ContadorEntidade.vue?vue&type=script&lang=js"
export * from "./ContadorEntidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports